'use client'

import * as React from 'react'
import { cn } from "@shared/utils"
import { FormItemContext } from '../../hooks/FormItemContext'

/**
 * @group Components
 * 
 * @summary
 * <blockquote>Wrapper component for a form item (e.g. label, input, error message).</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormItem } from '@shared/ui'
 * 
 * <FormItem>
 *   <FormLabel>Email</FormLabel>
 *   <FormControl>
 *     <Input type="email" />
 *   </FormControl>
 *   <FormMessage />
 * </FormItem>
 * ```
 */
export const FormItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const id = React.useId()

  return (
    <FormItemContext.Provider value={{ id }}>
      <div ref={ref} className={cn('space-y-2', className)} {...props} />
    </FormItemContext.Provider>
  )
})
FormItem.displayName = 'FormItem' 